"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.number.constructor");
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: "Sweiper",
  data: function data() {
    return {
      items: [],
      activeIndex: -1,
      containerWidth: 0,
      timer: null,
      resizeTimer: null,
      initPending: false,
      initRetryTimer: null,
      initRetryCount: 0,
      mountedReady: false,
      deactivatedState: false,
      visibilityProperty: null,
      visibilityEvent: null
    };
  },
  props: {
    initialIndex: {
      type: Number,
      default: 0
    },
    autoplay: {
      type: Boolean,
      default: true
    },
    loop: {
      type: Boolean,
      default: true
    },
    type: String,
    interval: {
      type: Number,
      default: 3000
    }
  },
  watch: {
    items: function items(val) {
      if (val.length > 0) {
        this.queueInit();
      } else {
        this.pauseTimer();
      }
    },
    activeIndex: function activeIndex(val, oldVal) {
      this.resetItemPosition(oldVal);
      if (oldVal > -1) {
        this.$emit("change", val, oldVal);
      }
    },
    autoplay: function autoplay(val) {
      val ? this.startTimer() : this.pauseTimer();
    },
    loop: function loop() {
      this.setActiveItem(this.activeIndex);
    },
    interval: function interval() {
      this.pauseTimer();
      this.startTimer();
    }
  },
  mounted: function mounted() {
    this.mountedReady = true;
    this.bindBrowserEvents();
    this.queueInit();
  },
  activated: function activated() {
    this.deactivatedState = false;
    this.queueInit();
  },
  deactivated: function deactivated() {
    this.deactivatedState = true;
    this.pauseTimer();
  },
  methods: {
    queueInit: function queueInit() {
      var _this = this;
      if (!this.mountedReady || this.initPending) return;
      this.initPending = true;
      this.$nextTick(function () {
        _this.initPending = false;
        _this.initCarousel();
      });
    },
    initCarousel: function initCarousel() {
      var _this2 = this;
      this.updateItems();
      if (!this.items.length || this.isDocumentHidden()) {
        this.pauseTimer();
        return;
      }
      if (!this.$el || !this.$el.offsetWidth) {
        if (this.initRetryCount < 5) {
          this.initRetryCount++;
          if (this.initRetryTimer) clearTimeout(this.initRetryTimer);
          this.initRetryTimer = setTimeout(function () {
            _this2.initRetryTimer = null;
            _this2.initCarousel();
          }, 100);
        }
        return;
      }
      this.initRetryCount = 0;
      this.normalizeActiveIndex();
      this.resetItemPosition(this.activeIndex);
      this.startTimer();
    },
    resetItemPosition: function resetItemPosition(oldIndex) {
      var _this3 = this;
      this.items.forEach(function (item, index) {
        item.translateItem(index, _this3.activeIndex, oldIndex);
      });
    },
    playSlides: function playSlides() {
      if (this.items.length < 2) {
        this.pauseTimer();
        return false;
      }
      if (this.activeIndex < this.items.length - 1) {
        this.activeIndex++;
      } else if (this.loop) {
        this.activeIndex = 0;
      } else {
        this.pauseTimer();
        return false;
      }
      return true;
    },
    updateItems: function updateItems() {
      var _this4 = this;
      var items = this.$children.filter(function (child) {
        return child.$options.name === "ElCarouselItem";
      });
      var changed = items.length !== this.items.length || items.some(function (item, index) {
        return item !== _this4.items[index];
      });
      if (changed) this.items = items;
      return this.items;
    },
    normalizeActiveIndex: function normalizeActiveIndex() {
      if (!this.items.length) {
        this.activeIndex = -1;
        return;
      }
      if (this.activeIndex < 0 || this.activeIndex >= this.items.length) {
        var initialIndex = Number(this.initialIndex);
        this.activeIndex = initialIndex >= 0 && initialIndex < this.items.length ? initialIndex : 0;
      }
    },
    pauseTimer: function pauseTimer() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
    },
    startTimer: function startTimer() {
      var _this5 = this;
      this.pauseTimer();
      if (this.interval <= 0 || !this.autoplay || this.items.length < 2 || this.deactivatedState || this.isDocumentHidden()) {
        return;
      }
      this.timer = setTimeout(function () {
        _this5.timer = null;
        if (_this5.playSlides()) _this5.startTimer();
      }, this.interval);
    },
    setActiveItem: function setActiveItem(index) {
      if (typeof index === "string") {
        var filteredItems = this.items.filter(function (item) {
          return item.name === index;
        });
        if (filteredItems.length > 0) {
          index = this.items.indexOf(filteredItems[0]);
        }
      }
      index = Number(index);
      if (isNaN(index) || index !== Math.floor(index)) {
        console.warn("[Element Warn][Carousel]index must be an integer.");
        return;
      }
      var length = this.items.length;
      if (!length) {
        this.activeIndex = -1;
        this.pauseTimer();
        return;
      }
      var oldIndex = this.activeIndex;
      if (index < 0) {
        this.activeIndex = this.loop ? length - 1 : 0;
      } else if (index >= length) {
        this.activeIndex = this.loop ? 0 : length - 1;
      } else {
        this.activeIndex = index;
      }
      if (oldIndex === this.activeIndex) {
        this.resetItemPosition(oldIndex);
      }
      this.resetTimer();
    },
    resetTimer: function resetTimer() {
      if (this.mountedReady) {
        this.pauseTimer();
        this.startTimer();
      }
    },
    getVisibilityProperty: function getVisibilityProperty() {
      if ("hidden" in document) return "hidden";
      if ("webkitHidden" in document) return "webkitHidden";
      if ("msHidden" in document) return "msHidden";
      return null;
    },
    getVisibilityEvent: function getVisibilityEvent() {
      if ("hidden" in document) return "visibilitychange";
      if ("webkitHidden" in document) return "webkitvisibilitychange";
      if ("msHidden" in document) return "msvisibilitychange";
      return null;
    },
    isDocumentHidden: function isDocumentHidden() {
      return this.visibilityProperty ? document[this.visibilityProperty] : false;
    },
    handleVisibilityChange: function handleVisibilityChange() {
      if (this.isDocumentHidden()) {
        this.pauseTimer();
      } else {
        this.queueInit();
      }
    },
    handleResize: function handleResize() {
      var _this6 = this;
      if (this.resizeTimer) clearTimeout(this.resizeTimer);
      this.resizeTimer = setTimeout(function () {
        _this6.resizeTimer = null;
        if (!_this6.isDocumentHidden() && _this6.items.length) {
          _this6.initRetryCount = 0;
          _this6.$nextTick(function () {
            return _this6.resetItemPosition(_this6.activeIndex);
          });
        }
      }, 100);
    },
    bindBrowserEvents: function bindBrowserEvents() {
      this.visibilityProperty = this.getVisibilityProperty();
      this.visibilityEvent = this.getVisibilityEvent();
      if (this.visibilityEvent) {
        document.addEventListener(this.visibilityEvent, this.handleVisibilityChange);
      }
      window.addEventListener("resize", this.handleResize);
    },
    unbindBrowserEvents: function unbindBrowserEvents() {
      if (this.visibilityEvent) {
        document.removeEventListener(this.visibilityEvent, this.handleVisibilityChange);
      }
      window.removeEventListener("resize", this.handleResize);
      if (this.resizeTimer) {
        clearTimeout(this.resizeTimer);
        this.resizeTimer = null;
      }
      if (this.initRetryTimer) {
        clearTimeout(this.initRetryTimer);
        this.initRetryTimer = null;
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.mountedReady = false;
    this.pauseTimer();
    this.unbindBrowserEvents();
  }
};